import { useEffect, useMemo, useState } from 'react';
import { IVariantData } from '../types/interfaces';
import { useTranslation } from 'react-i18next';
import VehicleModelsEditExterior from '../../vehicleModels/components/VehicleModelsEditExterior/VehicleModelsEditExterior';
import VehiclModelsEditSpecificationsTable from '../../vehicleModels/components/VehiclModelsEditSpecificationsTable';
import VehicleModelsEditSidebar from '../../vehicleModels/components/VehicleModelsEditSidebar';
import CreateVariantForm from './CreateVariantForm';
import { useSearchParams } from 'react-router-dom';

export default function VariantsEditLayout() {
  const { t } = useTranslation();
  const tabsData = useMemo(() => [
    {
      id: 1,
      name: t('main_info'),
      slug: 'main-info',
      content: <CreateVariantForm />
    },
    {
      id: 3,
      name: t('exterior_color_images'),
      slug: 'exterior-colors',
      content: <VehicleModelsEditExterior title={t('exterior_color_images')} variant />
    },
    {
      id: 6,
      name: t('interior_color_images'),
      slug: 'interior-colors',
      content: <VehicleModelsEditExterior title={t('interior_color_images')} interior variant />
    },
    {
      id: 5,
      name: t('specifications'),
      slug: 'specs',
      content: <VehiclModelsEditSpecificationsTable variant />
    }
  ], [t]);

  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  function findCurrentTabIndex(){
    const tabIndex = tabsData?.findIndex(item => item.name === tab)
    return tabIndex === -1 ? 0 : tabIndex
  }

  const [activeTab, setActiveTab] = useState(findCurrentTabIndex());

  useEffect(() => {
    setActiveTab(findCurrentTabIndex())
  }, [tab])

  return (
    <div className="model-edit">
      <VehicleModelsEditSidebar data={tabsData} activeTab={activeTab} setActiveTab={setActiveTab} />
      {tabsData[activeTab]?.content}
    </div>
  );
}
